import { mdiCogOutline, mdiClose } from "@mdi/js";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../../ui/components/button/Button";
export const NotificationControls = ({ noDismiss, allowSuppress, collapsed, onDismiss, onSuppress, }) => {
    const { t } = useTranslation(["common"]);
    if (noDismiss && !allowSuppress) {
        return null;
    }
    return (React.createElement("div", { className: "relative flex shrink-0 items-start gap-x-1" },
        allowSuppress && (React.createElement(Button, { buttonType: "tertiary", leftIconPath: mdiCogOutline, size: "xs", title: t("Never show again"), onClick: onSuppress })),
        !noDismiss && (React.createElement(Button, { buttonType: "tertiary", leftIconPath: mdiClose, size: "xs", title: collapsed > 1 ? t("Dismiss All") : t("Dismiss"), onClick: onDismiss }))));
};
